const DEFAULT_LAUNCH_TIMEOUT_MS = 60_000;
const LAUNCH_WATCHDOG_MARGIN_MS = 15_000;

export interface BrowserLaunchTimeouts {
  launchTimeoutMs: number;
  launchWatchdogMs: number;
}

/**
 * Resolve browser-launch budgets when a launch begins, rather than when this
 * module is imported. Hosts such as the MicroVM guest can therefore establish
 * policy during their own bootstrap even when browser-core is already loaded.
 */
export function resolveBrowserLaunchTimeouts(
  raw = process.env.PLAYWRIGHT_LAUNCH_TIMEOUT_MS
): BrowserLaunchTimeouts {
  const parsed = raw === undefined || raw === '' ? Number.NaN : Number(raw);
  const launchTimeoutMs =
    Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_LAUNCH_TIMEOUT_MS;

  return {
    launchTimeoutMs,
    launchWatchdogMs: launchTimeoutMs + LAUNCH_WATCHDOG_MARGIN_MS,
  };
}
